module.exports = __webpack_public_path__ + "static/img/11.b32a35c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/hangye/20200520/11.png
// module id = 8PQT
// module chunks = 1